/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MailReceiverDto,
    MailReceiverDtoFromJSON,
    MailReceiverDtoToJSON,
    MonitoredCertificateDto,
    MonitoredCertificateDtoFromJSON,
    MonitoredCertificateDtoToJSON,
} from '../models';

export interface AddMailReceiverRequest {
    mailReceiverDto: MailReceiverDto;
}

export interface DeleteMailReceiverRequest {
    mailReceiverId: string;
}

/**
 * 
 */
export class MonitoredCertificateRestControllerApi extends runtime.BaseAPI {

    /**
     */
    async addMailReceiverRaw(requestParameters: AddMailReceiverRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mailReceiverDto === null || requestParameters.mailReceiverDto === undefined) {
            throw new runtime.RequiredError('mailReceiverDto','Required parameter requestParameters.mailReceiverDto was null or undefined when calling addMailReceiver.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/pkix/add-mail-receivers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailReceiverDtoToJSON(requestParameters.mailReceiverDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addMailReceiver(mailReceiverDto: MailReceiverDto, initOverrides?: RequestInit): Promise<void> {
        await this.addMailReceiverRaw({ mailReceiverDto: mailReceiverDto }, initOverrides);
    }

    /**
     */
    async deleteMailReceiverRaw(requestParameters: DeleteMailReceiverRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.mailReceiverId === null || requestParameters.mailReceiverId === undefined) {
            throw new runtime.RequiredError('mailReceiverId','Required parameter requestParameters.mailReceiverId was null or undefined when calling deleteMailReceiver.');
        }

        const queryParameters: any = {};

        if (requestParameters.mailReceiverId !== undefined) {
            queryParameters['mailReceiverId'] = requestParameters.mailReceiverId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/delete-mail-receiver`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMailReceiver(mailReceiverId: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteMailReceiverRaw({ mailReceiverId: mailReceiverId }, initOverrides);
    }

    /**
     */
    async listMailReceiversRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<MailReceiverDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/mail-receivers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailReceiverDtoFromJSON));
    }

    /**
     */
    async listMailReceivers(initOverrides?: RequestInit): Promise<Array<MailReceiverDto>> {
        const response = await this.listMailReceiversRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async listMonitoredCertificatesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<MonitoredCertificateDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/pkix/monitored-certificates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MonitoredCertificateDtoFromJSON));
    }

    /**
     */
    async listMonitoredCertificates(initOverrides?: RequestInit): Promise<Array<MonitoredCertificateDto>> {
        const response = await this.listMonitoredCertificatesRaw(initOverrides);
        return await response.value();
    }

}
